export default __webpack_public_path__ + "static/media/hub_login-background.6e9fd409.svg";